Handlebars.registerPartial('partials/common/arrange_and_approve/approvers/manage', Handlebars.template({"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    var lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "<button type=\"button\" class=\"modal-opener btn btn-text-action btn-small btn-no-margin\" data-target-modal=\"approvers-by-level-1\" data-level=\"1\">\n  <span class=\"btn-label no-side-padding\">"
    + container.escapeExpression((lookupProperty(helpers,"i18nMsg")||(depth0 && lookupProperty(depth0,"i18nMsg"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),"arrange_and_approve_manage_label",{"name":"i18nMsg","hash":{},"data":data,"loc":{"start":{"line":2,"column":42},"end":{"line":2,"column":89}}}))
    + "</span>\n</button>";
},"useData":true}));